
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';

    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Imagen } from '@/__env/lib/Articulos/Imagenes';
    import { Wait } from '@/__env/ext';
    import FileSaver from 'file-saver';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        @Prop()
        public Abierto: boolean;
        @Watch( 'Abierto' )
        onAbierto()
        {
            if ( this.Abierto && !this.Iniciado )
                this.Iniciar();
        }

        public get Articulo() { return this.Controlador.Articulo; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public Cargando: boolean = false;
        public SeleccionarArchivo: boolean = false;
        public Seleccionada: Imagen = null;
        @Watch( 'Seleccionada' )
        onSeleccionada()
        {
            if ( this.Seleccionada )
            {
                this.TipoSeleccionado = '';
                this.ImagenSeleccionada = this.Seleccionada.Archivo500;
                this.DescargarImagenSeleccionada = this.Seleccionada.DescargarArchivo500;
                this.Refrescar();
                this.TipoSeleccionado = 'Imagen 500*500';
            }
        }

        public TipoSeleccionado: string = '';
        @Watch( 'TipoSeleccionado' )
        onTipoSeleccionado()
        {
            if ( this.TipoSeleccionado == 'Imagen de base' )
            {
                this.ImagenSeleccionada = this.Seleccionada.Archivo;
                this.DescargarImagenSeleccionada = this.Seleccionada.DescargarArchivo;
                this.ImagenSeleccionadaWidth = 400;
            }
            else if ( this.TipoSeleccionado == 'Miniatura' )
            {
                this.ImagenSeleccionada = this.Seleccionada.Miniatura;
                this.DescargarImagenSeleccionada = this.Seleccionada.DescargarMiniatura;
                this.ImagenSeleccionadaWidth = 150;
            }
            else if ( this.TipoSeleccionado == 'Imagen 500*500' )
            {
                this.ImagenSeleccionada = this.Seleccionada.Archivo500;
                this.DescargarImagenSeleccionada = this.Seleccionada.DescargarArchivo500;
                this.ImagenSeleccionadaWidth = 400;
            }
            else if ( this.TipoSeleccionado == 'Imagen 1000*1000' )
            {
                this.ImagenSeleccionada = this.Seleccionada.Archivo1000;
                this.DescargarImagenSeleccionada = this.Seleccionada.DescargarArchivo1000;
                this.ImagenSeleccionadaWidth = 400;
            }
        }

        public Iniciado: boolean = false;
        public ImagenSeleccionada: string = null;
        public DescargarImagenSeleccionada: string = null;

        public ImagenSeleccionadaWidth: number = 600;
        public Imagenes: Imagen[] = [];

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {
            //this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( x => this.Iniciar() ) );
            //this.Iniciar();
        }

        async Iniciar()
        {
            this.Imagenes.clear();
            await this.Articulo.CargarImagenes();
            if ( this.Articulo.Imagenes.hasRows() )
            {
                console.log('eaea' );
                this.Iniciado = true;
                this.Imagenes.push( ...this.Articulo.Imagenes );
            }
        }

        public async AgregarArchivo( archivo: File )
        {
            if ( !archivo )
                return;
            this.Cargando = true;
            await Wait( 1000 );
            let ar = await this.Articulo.SubirImagen( archivo );
            if ( ar )
            {
                this.Iniciar();
            } else
            {
                this.$EventBus.Notificaciones.Error( 'Error al subir el archivo' );
            }


            this.Cargando = false;
        }

        public async Eliminar( imagen: Imagen )
        {
            if ( !await Utiles.Mensajes.SiNo( 'Eliminar imagen', '¿Está seguro?' ) )
                return;

            let ar = await imagen.del();
            if ( ar )
            {
                this.Articulo.Imagenes.splice( this.Imagenes.findIndex( x => x.Id == imagen.Id ), 1 );
                this.Imagenes.splice( this.Imagenes.findIndex( x => x.Id == imagen.Id ), 1 );
            } else
            {
                this.$EventBus.Notificaciones.Error( 'Error al eliminar el archivo' );
            }
            this.Cargando = false;
        }

        public async Principal( imagen: Imagen )
        {
            let ar = await imagen.MarcarPrincipal( !imagen.esPrincipal );
            if ( ar )
            {
                await this.Articulo.CargarImagenes();
                this.Iniciar();
            } else
            {
                this.$EventBus.Notificaciones.Error( 'Error al eliminar el archivo' );
            }
        }

        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

        public Descargar( url: string )
        {
            FileSaver.saveAs( url );
        }

    }
